<template>
    <v-flex xs12 class="create-profile pt-4" id="coupon-create-profile">
        <v-layout row wrap>
            <v-flex xs12>
                <v-btn
                    class="ma-0 button-secondary-color"
                    aria-label="coupon-create-profile"
                    rounded
                    tabindex="-1"
                    aria-hidden="true"
                    data-testid="coupon-create-profile"
                    @click="redirectToRegister"
                >
                    <v-icon light left class="ml-5">
                        add_circle
                    </v-icon>
                    <span class="btn-txt ml-2">
                        {{ $t('coupon.createProfile') }}
                    </span>
                </v-btn>
            </v-flex>
            <v-flex xs12 class="text-center">
                <v-btn
                    text
                    small
                    class="py-0"
                    tabindex="-1"
                    aria-hidden="true"
                    @click="showAdvantageModal = true"
                >
                    <span>{{ $t('coupon.whyCreateProfile') }}</span>
                </v-btn>
            </v-flex>
        </v-layout>
        <advantage-profile-modal
            v-if="showAdvantageModal"
            @close="showAdvantageModal = false"
            @redirectToRegister="redirectToRegister" />
    </v-flex>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import AdvantageProfileModal from '@/components/coupon/AdvantageProfileModal/AdvantageProfileModal';
import { isUsingKc } from '@/utils';
export default {
    name: 'coupon-create-profile',
    components: {
        AdvantageProfileModal,
    },
    props: {
        clientData: { type: Object, required: true },
    },
    data() {
        return {
            showAdvantageModal: false,
        };
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
        }),
    },
    methods: {
        ...mapActions({
            openRegisterWindow: 'jwt/openRegisterWindow',
            openKcRegisterWindow: 'kcLogin/openRegisterWindow',
        }),
        redirectToRegister() {
            if (isUsingKc) {
                this.openKcRegisterWindow();
                return;
            }
            this.openRegisterWindow({
                clientDataForUrl: {
                    ...this.clientData,
                    locale: this.locale,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.create-profile {
    background: #fff;
    text-align: center;
    .v-btn {
        padding: 30px 20px;
    }
    .v-icon {
        font-size: 60px;
        position: relative;
        left: -20px;
    }
    .btn-txt {
        position: relative;
        left: -10px;
        font-size: large
    }
}
</style>
